import PrXMarkComponent from './pr-x-mark';

export default PrXMarkComponent;
